module.exports = __webpack_public_path__ + "img/strongmen10.e8969c80.jpg";